import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import Header from "./components/Header";
import Hero from "./components/Hero";
import BankMarquee from "./components/BankMarquee";
import Solutions from "./components/Solutions";
import HowItWorks from "./components/HowItWorks";
import VideoSection from "./components/VideoSection";
import InterestCalculator from "./components/InterestCalculator";
import Testimonials from "./components/Testimonials";
import TeamSection from "./components/TeamSection";
import FAQ from "./components/FAQ";
import UKEconomySection from "./components/UKEconomySection";
import Insights from "./components/Insights";
import CTASection from "./components/CTASection";
import Footer from "./components/Footer";
import Dashboard from "./pages/Dashboard";
import SolutionPage from "./pages/SolutionPage";
import InfoPage from "./pages/InfoPage";
import CareersPage from "./pages/CareersPage";
import ContactPage from "./pages/ContactPage";
import UKDepositsPage from "./pages/UKDepositsPage";
import TopRates from "./components/TopRates";
import { LanguageProvider } from "./i18n/LanguageProvider";
import InsightsPage from "./pages/InsightsPage";
import LegalDoc from "./pages/LegalDoc";
import CookieConsent from "./components/CookieConsent";
import { AuthProvider } from "./context/AuthContext";
import { UIProvider, useUI } from "./context/UIContext";

function useReveal() {
  const location = useLocation();
  useEffect(() => {
    const els = document.querySelectorAll(".reveal");
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("is-visible");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, [location.pathname]);
}

function Home() {
  const { openIllustration } = useUI();
  const location = useLocation();
  useReveal();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 300);
    } else {
      window.scrollTo(0, 0);
    }
  }, [location.hash]);

  return (
    <div className="bg-white">
      <Header />
      <main>
        <Hero onIllustration={openIllustration} />
        <BankMarquee />
        <Solutions onIllustration={openIllustration} />
        <HowItWorks />
        <VideoSection />
        <InterestCalculator />
        <TopRates />
        <Testimonials />
        <TeamSection />
        <UKEconomySection />
        <FAQ />
        <Insights />
        <CTASection
          onIllustration={openIllustration}
        />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <div className="App notranslate">
      <AuthProvider>
        <BrowserRouter>
          <LanguageProvider>
          <UIProvider>
            <CookieConsent />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/solutions/:slug" element={<SolutionPage />} />
              <Route path="/insights" element={<InsightsPage />} />
              <Route path="/careers" element={<CareersPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/uk-fixed-deposits" element={<UKDepositsPage />} />
              <Route path="/fscs" element={<InfoPage />} />
              <Route path="/currencies" element={<InfoPage />} />
              <Route path="/security" element={<InfoPage />} />
              <Route path="/about" element={<InfoPage />} />
              <Route path="/legal" element={<InfoPage />} />
              <Route path="/privacy" element={<LegalDoc />} />
              <Route path="/terms" element={<LegalDoc />} />
              <Route path="/cookies" element={<LegalDoc />} />
            </Routes>
          </UIProvider>
          </LanguageProvider>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
